/**
 * User: WangMeng
 * Date: 2018-07-17
 * Time: 14:19
 * Desc: 标题额外内容.
 */
import './extraInfoTitle.scss';
import React from 'react';
import cns from 'classnames';

export default function ExtraInfoTitle({ explain, riskScore, fraudScore, industry, className, ...other}) {
    explain = explain === '该公司在营运能力方面存在显著风险' || explain === '该公司不存在显著风险' ? '' : explain;

    return (
        <div {...other} className={cns('extra-info-title', className)}>
            {riskScore && (
                <span className="extra-item">
                    <i className="iconfont icon-pingfen" />
                    风险评分：{riskScore}分
                </span>
            )}
            {fraudScore && (
                <span className="extra-item">
                    <i className="iconfont icon-pingfen" />
                    舞弊评分：{fraudScore}分
                </span>
            )}
            {explain && (
                <span className="extra-item">
                    <i className="iconfont icon-tishi" />
                    说明：{explain}
                </span>
            )}
            {/* {industry && (
                <span className="extra-item industry">
                    <i className="iconfont icon-biaoqian" />
                    公司分类：{industry}
                </span>
            )}*/}
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/common/extraInfoTitle/ExtraInfoTitle.jsx